import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TabContainer, Tab } from './styles';

export const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { path: '/transfer', label: 'Transfer' },
    { path: '/swap', label: 'Swap' },
    // { path: '/spark', label: 'Spark' },
    { path: '/progress', label: 'Progress' },
    // { path: '/admin', label: 'Admin' }
  ];

  return (
    <TabContainer>
      {tabs.map(tab => (
        <Tab
          key={tab.path}
          $active={location.pathname === tab.path}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </Tab>
      ))}
    </TabContainer>
  );
};